// Include Lightbox
import PhotoSwipeLightbox from 'photoswipe/lightbox';
// Caption Plugin für PhotoSwipe
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';
// Tooltips
import {delegate} from 'tippy.js';

// Wenn man hart verzweifelt jQuery am Leben halten will

// Include jQuery
const $ = require('jquery');

// jQuery Definitionen
window.jQuery = $;
window.$ = $;


// Ich weine ... jQuery Animationen kommen inzwischen aus jQuery UI
require('jquery-ui/ui/effects/effect-slide');
require('jquery-ui/ui/effects/effect-fade');
// vendors
require('lazysizes');

// includes
require('./vendor/modernizr.touch.svg.js');
require('./include/slick-content.js');

let firstvalidate = true;

/**
 * Implementiert Event Bubbling für Elemente mit einer bestimmten Klasse oder per ID.
 *
 * @param {string|HTMLElement} selectorOrElement - Der Selektor oder das Element, für das das Event abgefangen werden soll.
 * @param {string} eventName - Der Name des abzufangenden Ereignisses (z.B. "click").
 * @param {Function} callback - Die Callback-Funktion, die aufgerufen wird, wenn das Ereignis ausgelöst wird.
 * @param {Document} [context=document] - Das Kontext-Element, in dem die Suche durchgeführt werden soll (Standardwert ist das gesamte Dokument).
 * @returns {Function} - Eine Funktion zum Entfernen des Event-Listeners.
 */
const bubbleEvent = (selectorOrElement, eventName, callback, context = document) => {
  /**
   * Event-Handler für das abgefangene Ereignis.
   *
   * @param {Event} event - Das ausgelöste Ereignis.
   */
  function eventHandler(event) {
    let target = event.target;

    // Durchlaufe die Elemente in der Hierarchie, bis das Kontext-Element erreicht ist.
    while (target && target !== context) {
      if (typeof selectorOrElement === 'string') {
        if (target.matches(selectorOrElement)) {
          // Rufe die Callback-Funktion im Kontext des Ziel-Elements auf.
          callback.call(target, event);
        }
      } else {
        if (target === selectorOrElement) {
          // Rufe die Callback-Funktion im Kontext des Ziel-Elements auf.
          callback.call(target, event);
        }
      }
      target = target.parentElement;
    }
  }

  // Füge den Event-Listener dem Kontext-Element hinzu.
  context.addEventListener(eventName, eventHandler);

  // Gib eine Funktion zurück, um den Event-Listener später zu entfernen.
  return function() {
    context.removeEventListener(eventName, eventHandler);
  };
};
// Global
window.bubbleEvent = bubbleEvent;

// Ajax-Formulare
/**
 * Ajax form for typo3
 * @param conf
 */
function mpAjaxForm(conf) {
  // Das erste Formular im ausgewählten Element finden
  const form = conf.querySelector('form:first-of-type');

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    // Wert des input[name=ajaxform]-Felds aus dem Formular abrufen
    const ajaxForm = form.querySelector('input[name=ajaxform]').value;

    // Formular per Ajax senden?
    if (ajaxForm > 0 && form.getAttribute('enctype') !== 'multipart/form-data') {
      // Name des input[name=ajaxform]-Felds ändern
      form.querySelector('input[name=ajaxform]').setAttribute('name', 'ajax_form');

      // Formulardaten sammeln
      const form_data = new FormData(form);

      // Fetch-API für Ajax-Anfrage nutzen
      fetch(form.getAttribute('action'), {
        method: form.getAttribute('method'),
        body: form_data,
      }).then((response) => response.text()).then((html) => {
        // HTML-Code in das DOM einfügen
        const cAjaxForm = document.querySelector('#c' + ajaxForm);
        cAjaxForm.outerHTML = html;

        // Eventlistener für das neu eingefügte Formular hinzufügen
        mpAjaxForm.call(conf, conf);

        // Bei Bedarf zum neu eingefügten Formular scrollen
        const formTop = cAjaxForm.offsetTop;
        if (window.pageYOffset > formTop) {
          window.scrollTo({top: formTop, behavior: 'smooth'});
        }
      });
    }
  });
}

// Ajax-Formulare (NonTypo-Forms)
(function ($) {
    $.fn.ajaxForm = function (conf) {
        var defaults = {};
        // eslint-disable-next-line no-unused-vars
        var config = $.extend(defaults, conf);
        $(this).on('submit', function () {
            var form = $(this);
            // Formular per Ajax senden?
            if (form.data('action') && $(form).attr('enctype') !== 'multipart/form-data') {
                var form_data = $(this).find('input:not([type=checkbox],[type=submit],[type=image],[type=reset]), input[type=checkbox]:checked, input[type=radio]:checked, textarea, select').serialize();
                $.ajax({
                    url: form.data('action'),
                    type: form.attr('method'),
                    data: form_data,
                    success: function (html) {
                        $(form).replaceWith(html);
                    }
                });
                return false;
            }
        });
        return this;
    };
    // eslint-disable-next-line no-undef
})(jQuery);

function stickyHeaderControl() {
  // Initialisierung der Datenattribute beim ersten Aufruf der Seite
  if (!document.body.classList.contains('init-sticky-header')) {
    // tmpScrollPos | Aktuelle ScrollPosition, die nur nach Erreichen der scrollStepDif aktualisiert wird
    document.body.setAttribute('data-tmpscrollpos', window.scrollY);
    // tmpLiveScrollPos | Aktuelle ScrollPosition, die ständig aktualisiert wird
    document.body.setAttribute('data-tmplivescrollpos', window.scrollY);
    // isFixed | Status, ob Header fixed ist
    document.body.setAttribute('data-isfixed', 'false');
    // Klasse init-sticky-header setzen, damit die Funktion nicht mehrmals aufgerufen wird
    document.body.classList.add('init-sticky-header');
  }

  const fixedElement = document.getElementById('header-inner');
  const scrollStepDif = 200;
  const additionalHeader = document.getElementById('additional-header');

  let fixedFrom = additionalHeader.offsetTop + additionalHeader.offsetHeight;
  if (document.documentElement.classList.contains('no-touchevents') && window.innerWidth >= 1024) {
    fixedFrom = additionalHeader.offsetTop + additionalHeader.getBoundingClientRect().height + document.getElementById('header-inner').querySelector('.content-limiter').offsetHeight;
  }

  // das Fixieren
  if (window.scrollY >= fixedFrom) {
    if (document.body.getAttribute('data-isfixed') === 'false') {
      document.body.setAttribute('data-tmpscrollpos', window.scrollY);
      document.querySelector('#header').nextElementSibling.style.paddingTop = (fixedElement.offsetHeight + parseInt(window.getComputedStyle(document.querySelector('#header').nextElementSibling).paddingTop)) + 'px';
    }
    fixedElement.classList.add('fixed');
    fixedElement.style.position = 'fixed';
    document.body.setAttribute('data-isfixed', 'true');
  } else {
    fixedElement.classList.remove('fixed');
    fixedElement.style.position = 'relative';
    fixedElement.style.top = '0';
    document.body.setAttribute('data-isfixed', 'false');
    document.querySelector('#header').nextElementSibling.removeAttribute('style');
  }

  // das Ausblenden
  if (document.body.getAttribute('data-isfixed') === 'true') {
    if (document.documentElement.classList.contains('touchevents')) {
      if (((parseInt(document.body.getAttribute('data-tmpscrollpos')) - window.scrollY) < -Math.abs(scrollStepDif) || parseInt(document.body.getAttribute('data-tmplivescrollpos')) > window.scrollY)) {
        if (parseInt(document.body.getAttribute('data-tmpscrollpos')) < window.scrollY) {
          fixedElement.style.top = '-' + fixedElement.offsetHeight + 'px';
        } else {
          fixedElement.style.top = '0';
        }
        document.body.setAttribute('data-tmpscrollpos', window.scrollY);
      }
    } else {
      if (window.innerWidth >= 1024) {
        fixedElement.style.top = '-' + (fixedElement.offsetHeight - document.querySelector('#menu').offsetHeight) + 'px';
      } else {
        fixedElement.style.top = '0';
      }
    }
  }

  document.body.setAttribute('data-tmplivescrollpos', window.scrollY);
}

/* Mobiles Menü muss je nach Höhe des Headers anders ausgerichtet sein */
function mobileMenuTopDistance() {
  const fixedElement = document.querySelector('#layout > #header > #header-inner');
  let headerBottom = fixedElement.getBoundingClientRect().top + fixedElement.offsetHeight;

  if (document.body.getAttribute('data-isfixed') === 'false') {
    headerBottom -= window.scrollY;
  }

  document.querySelector('#menu').style.top = headerBottom + 'px';
  if (document.querySelector('#menu-overlay')) {
    document.querySelector('#menu-overlay').style.top = headerBottom + 'px';
  }
}

/* Das setzen der äußeren Klasse des Sektionmenüs + das Fixieren des Sektionmenüs */
var smzindex = 100;

function stickySectionmenuInit() {
  $('.csc-sectionmenu').each(function() {
    // Z-Index erhöhen pro Element
    smzindex = smzindex + 1;
    // Elemente Wrappen und Klasse setzen
    if (!$(this).closest('.csc-sectionmenu-outer').length) {
      $(this).closest('.csc-frame-wrap').addClass('csc-sectionmenu-wrap').wrapAll('<div class="csc-sectionmenu-outer"></div>');
    }
    // Z-Index setzen und Höhe auf Elternelement setzen
    $(this).closest('.csc-sectionmenu-wrap').css('z-index', smzindex).closest('.csc-sectionmenu-outer').css('height', $(this).closest('.csc-sectionmenu-wrap').outerHeight());
  });
}

function stickySectionmenuControl() {
  $('.csc-sectionmenu').each(function() {
    var ele = $(this);
    var smfixedElement = ele.closest('.csc-sectionmenu-wrap');
    var smfixedfrom;
    if (smfixedElement.closest('.csc-sectionmenu-outer').length) {
      smfixedfrom = smfixedElement.closest('.csc-sectionmenu-outer').offset().top - ($('#menu').outerHeight() - 1);
    }
    // das Fixieren
    if ($(document).scrollTop() >= smfixedfrom) {
      smfixedElement.addClass('fixed').css({'position': 'fixed', 'top': ($('#menu').outerHeight() - 1)});
    } else {
      smfixedElement.removeClass('fixed').css({'position': 'relative', 'top': '0'});
      $('#header-inner').css('z-index', '105');
    }

    // Aktiver Menüpunkt
    var linkedeleobj = {};
    ele.children('div:first').find('a').each(function() {
      var aele = $(this);
      var linkedele = $(aele.attr('href'));
      var linkedeleOffsetTop = linkedele.offset().top;
      var activeSince = Math.ceil(linkedeleOffsetTop - ($(window).height() / 3 * 1));

      aele.removeClass('active');

      linkedeleobj[activeSince] = aele.attr('href');

    });
    /*console.log('UNORDERED');
     console.log(linkedeleobj);*/

    var ordered = {};
    Object.keys(linkedeleobj).sort().forEach(function(key) {
      ordered[key] = linkedeleobj[key];
    });
    /*console.log('ORDERED');
     console.log(ordered);
     console.log('-------------------');*/
    $.each(ordered, function(index, value) {
      if (index < $(document).scrollTop()) {
        ele.children('div:first').find('a').removeClass('active');
        $('a[href="' + value + '"]').addClass('active');
      }
    });
  });
}

/* Suchfilter der Trainingsübersichtsseiten */
function ajaxAdacForm() {
  $('#tr-filter').submit(function() {
    var get_data = $(this).find('input[type=text], input[type=hidden], input[type=password], input[type=checkbox]:checked, input[type=radio]:checked, textarea, select').serialize();
    //showAjaxLoader();
    $.ajax({
      url: 'ajax/ajax.adac_trainings.php',
      type: 'get',
      data: {userfilter: get_data},
      success: function(html) {
        $('#tr-overview').html(html);
        $('.filter-item').on('click', function() {
          var inputid = $(this).data('inputid').replace('[', '\\[').replace(']', '\\]');
          $('#' + inputid).trigger('click');
          $('#tr-filter').submit();
        });
        $('.filter-remove').on('click', function() {
          $('#tr-filter').find('.input-checkbox').find('input').prop('checked', false);
          $('#tr-filter').submit();
        });
        //hideAjaxLoader();
        //ajaxAdacForm();
      },
    });
    return false;
  });
}

/* Das Verarbeiten der Custom Plugins des Ckeditor */
function handleRtePlugins() {
  /* Social Share (Home-Link) */
  if ($('span[class*=social-share-]').length) {
    $('span[class*=social-share-]').each(function() {
      var ele = $(this);
      var eleclass = ele.attr('class');
      var elecontent = ele.html();
      var homelink = $('body').data('home');
      var hometitle = $('body').data('hometitle');
      var target = '';
      if (eleclass !== 'social-share-mail') {
        target = ' target="_blank"';
      }
      var link;
      if (eleclass === 'social-share-facebook') {
        link = 'http://www.facebook.com/share.php?u=' + homelink;
      }
      if (eleclass === 'social-share-twitter') {
        link = 'http://twitter.com/home?status=' + hometitle + ': ' + homelink;
      }
      if (eleclass === 'social-share-mail') {
        link = 'mailto:?subject=Empfehlung%3A%20Fahrsicherheitstraining%20in%20Embsen%20bei%20Lüneburg&body=Hallo%2C%0A%0Aein%20Fahrsicherheitstraining%20in%20Embsen%20bei%20Lüneburg%20k%C3%B6nnte%20Dich%20auch%20interessieren.%20Mehr%20dazu%3F%20Findest%20du%20hier%3A%0A' + homelink + '%0A%0AViele%20Gr%C3%BC%C3%9Fe';
      }
      if (eleclass === 'social-share-whatsapp') {
        link = 'whatsapp://send?text=Hallo, ein Fahrsicherheitstraining in Embsen bei Lüneburg könnte Dich auch interessieren. Mehr dazu? Findest du hier: ' + homelink;
      }
      var starttag = '<a class="' + eleclass + '" href="' + link + '"' + target + '>';
      var endtag = '</a>';
      ele.replaceWith(starttag + elecontent + endtag);
    });
  }
}

// Die Höhe der Footer-Menüs im Dekstop müssen angepasst werden, damit die letzen Elemente in 2er Gruppen untereinander sind
function footerMenuHeightDesktop() {
  if ($(window).width() >= 1200) {
    var menuwrap = $('#footer-menu').children('.content-limiter');
    var highestHeight = 0; // Die Höhe, die später auf Element 1 und 2 und auf den Container angewendet wird

    // Max Höhe der ersten beiden Menü-Elemente ermitteln
    var heightBigElements = 0;
    menuwrap.find('.csc-frame-wrap:nth-child(1),.csc-frame-wrap:nth-child(2)').each(function() {
      if ($(this).outerHeight() > heightBigElements) {
        heightBigElements = $(this).outerHeight();
      }
    });
    // Max Höhe von 2 Elementen übereinander ermitteln (ab Element 3)
    var counterSmallElements = 0; // Benötigt um bei jedem 3. Element von neuem zu Beginnen, damit man 2 Elemente die Höhe zusammen rechnen kann
    var heightSmallElements = 0; // Hier wird die Höhe eines 2er Paars eingefügt
    var heightSmallElementsTmp = 0; // Tmp fürs zusammenrechnen von 2 Elementen
    menuwrap.find('.csc-frame-wrap:not(:nth-child(1)):not(:nth-child(2))').each(function() {
      counterSmallElements++;
      // 2 Elemente immer die Höhe zusammenrechnen, danach TMP & counter resetten und die aktuelle höchste Höhe in heightSmallElements lagern
      if (counterSmallElements > 2) {
        if (heightSmallElementsTmp > heightSmallElements) {
          heightSmallElements = heightSmallElementsTmp;
        }
        counterSmallElements = 1;
        heightSmallElementsTmp = 0;
      }
      heightSmallElementsTmp += $(this).outerHeight();
    });
    // aktuelle höchste Höhe in heightSmallElements lagern, hier nochmal, falls die Zahl der Elemente ungerade ist
    if (heightSmallElementsTmp > heightSmallElements) {
      heightSmallElements = heightSmallElementsTmp;
    }

    // Die höchte Höhe ermitteln
    if (heightBigElements > heightSmallElements) {
      highestHeight = heightBigElements;
    } else {
      highestHeight = heightSmallElements;
    }

    // Höhe auf Wrap und die ersten beiden Elementen
    menuwrap.css('height', (highestHeight + parseInt(menuwrap.css('padding-top')) + parseInt(menuwrap.css('padding-bottom')) + 15) + 'px').find('.csc-frame-wrap:nth-child(1),.csc-frame:nth-child(2)').each(function() {
      $(this).css('height', Math.ceil(highestHeight) + 'px');
    });
    menuwrap.find('.csc-frame-wrap:not(:nth-child(1)):not(:nth-child(2))').each(function() {
      $(this).css('height', Math.ceil(highestHeight / 2) + 'px');
    });
  } else {
    // Höhe auf Wrap und die ersten beiden Elementen
    $('#footer-menu').children('.content-limiter').removeAttr('style').find('.csc-frame-wrap').each(function() {
      $(this).removeAttr('style');
    });
  }
}

const validateInput = (input) => {
  var inputtag = input.tagName.toLowerCase();
  // Input-Type
  var inputtype = '';
  if (inputtag == 'input') {
    inputtype = input.getAttribute('type');
  }
  // Validierungen
  var rules = [];
  if (input.dataset.rules) {
    rules = input.dataset.rules.split(' ');
  }

  // Buttons und Hidden müssen nicht überprüft werden
  if ((inputtype == 'submit') || (inputtype == 'reset') || (inputtype == 'button') || (inputtype == 'hidden')) {
    return false;
  }

  // Checkboxen und Radio nur checken, ob was ausgewählt ist
  if ((inputtype == 'checkbox') || (inputtype == 'radio')) {
    if ((inputtype == 'radio')) {
      // Radio
      // Bei Radio muss die Gruppe gecheckt werden, ob eines ausgewählt ist
      var groupname = input.getAttribute('name');
      groupname = groupname.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
      var groupelements = document.querySelectorAll('input[name=' + groupname + ']');
      var isSelected = false;

      groupelements.forEach((groupelement) => {
        if (groupelement.checked) {
          isSelected = true;
        }
      });

      groupelements.forEach((groupelement) => {
        if (isSelected) {
          groupelement.parentElement.classList.add('good');
        } else {
          groupelement.parentElement.classList.remove('good');
        }
      });
    } else {
      // Checkbox
      if (input.checked) {
        input.parentElement.classList.add('good');
      } else {
        input.parentElement.classList.remove('good');
      }
    }
  } else {
    // Prüfen ob Inhalt enthalten ist
    if (input.value.trim() !== '') {
      input.classList.add('not-empty');
    } else {
      input.classList.remove('not-empty');
    }

    // Bei erstaufruf fehlerbehaftete Felder nicht überprüfen
    if (firstvalidate === true) {
      if (input.parentElement.classList.contains('err') || input.parentElement.parentElement.classList.contains('csc-form-element-error')) {
        return false;
      }
    }

    // Gültigkeit prüfen
    var regex = '';
    if (input.value.trim() !== '') {
      // Validierung nur bei gefülltem Input
      var value = input.value;
      var status = true;

      // Nummern Regex
      // Regex aufbauen
      var whitespace = '';
      // Custom Validierung über Data-Attribut möglich
      if (input.dataset.regex) {
        regex = new RegExp(input.dataset.regex);

        if (!value.match(regex)) {
          status = false;
        }
      } else {
        // Typo3 Form Validations und teils input-types (z.B. type="email")
        // if (jQuery.inArray('alphabetic', rules) !== -1) { code unten ohne jQuery

        if (rules.includes('alphabetic')) {
          if (rules.includes('alphabetic-whitespace')) {
            whitespace = '\\s';
          }
          regex = new RegExp('^[a-zäöüÄÖÜß' + whitespace + ']*$', 'i');

          if (!value.match(regex)) {
            status = false;
          }
        }
        if (rules.includes('alphanumeric')) {
          if (rules.includes('alphanumeric-whitespace')) {
            whitespace = '\\s';
          }
          regex = new RegExp('^[a-zäöüÄÖÜß0-9' + whitespace + ']*$', 'i');

          if (!value.match(regex)) {
            status = false;
          }
        }
        if (rules.includes('between')) {
          regex = new RegExp('^[-]?[0-9]+$');

          if (value.match(regex)) {
            var betweenmin = parseInt(input.dataset.betweenmin);
            var betweenmax = parseInt(input.dataset.betweenmax);
            if (rules.includes('between-inclusive')) {
              betweenmin++;
              betweenmax--;
            }
            if (parseInt(value) > betweenmax) {
              status = false;
            }
            if (parseInt(value) < betweenmin) {
              status = false;
            }
          } else {
            status = false;
          }
        }
        if (rules.includes('date')) {
          var dateformat = input.dataset.dateformat;
          dateformat = dateformat.replace('%e', '\\d{1,2}');
          dateformat = dateformat.replace('%m', '\\d{1,2}');
          dateformat = dateformat.replace('%Y', '\\d{4}');
          dateformat = dateformat.replace('%d', '\\d{1,2}');
          dateformat = dateformat.replace('.', '\\.');
          dateformat = dateformat.replace('-', '\\-');

          regex = new RegExp('^' + dateformat + '$');

          if (!value.match(regex)) {
            status = false;
          }
        }
        if (rules.includes('digit')) {
          regex = new RegExp('^[0-9]{1}$');

          if (!value.match(regex)) {
            status = false;
          }
        }
        if (inputtype === 'email' || rules.includes('email')) {
          // Non-ASCII-Chars are not allowed
          var nonascii = '\u0080-\u00FF'; // Unicode Escape Sequenzen für 128-255
          // Erlaubte Domainzeichen (UTF-8)
          var legalchars = 'a-zA-Z0-9àáâãäåæāăąçćĉċčďđèéêëēĕėęěĝğġģĥħìíîïĩīĭįıðĵķĸĺļľłñńņňŋòóôõöøōŏőœŕŗřśŝşšţťŧùúûüũūŭůűųÿŷŵýźżžþßŀŉșțΐάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώабвгдежзийклмнопрстуфхцчшщъыьэюяἀἁἂἃἄἅἆἇἐἑἒἓἔἕἠἡἢἣἤἥἦἧἰἱἲἳἴἵἶἷὀὁὂὃὄὅὐὑὒὓὔὕὖὗὠὡὢὣὤὥὦὧὰὲὴὶὸὺὼᾀᾁᾂᾃᾄᾅᾆᾇᾐᾑᾒᾓᾔᾕᾖᾗᾠᾡᾢᾣᾤᾥᾦᾧᾰᾱᾲᾳᾴᾶᾷῂῃῄῆῇῐῑῒῖῗῠῡῢῤῥῦῧῲῳῴῶῷ';

          // Erlaubte Benutzerzeichen (vor dem @)
          var userchars = legalchars + '!#$%&\'*+-/=?^`{|}~';

          var nqtext = '[^\\\\' + nonascii + '\x0D\x0A"]';
          var qchar = '\\\\[^' + nonascii + ']';

          var protocol = '(?:mailto:)';

          var normuser = '[' + userchars + '][' + userchars + '_\\.-]*';
          var quotedstring = '"(?:' + nqtext + '|' + qchar + ')+"';
          var user_part = '(?:' + normuser + '|' + quotedstring + ')';

          var dom_mainpart = '[' + legalchars + '][' + legalchars + '_\\.-]*\\.';
          var dom_subpart = '(?:[' + legalchars + '][' + legalchars + '_\\.-]*\\.)*';
          var dom_tldpart = '[a-zA-Z]{2,}';
          var domain_part = dom_subpart + dom_mainpart + dom_tldpart;

          regex = new RegExp('^' + protocol + '?' + user_part + '\\@' + domain_part + '$');

          if (!value.match(regex)) {
            status = false;
          }
        }
        if (rules.includes('equals')) {
          var equalsfield = input.dataset.equalsfield;
          // In einem Mail-Formular von Typo3 muss der Feldname zum Suchen angepasst werden, da das name-attribut nicht geeignet ist
          if (input.closest('form').parentElement.classList.contains('csc-mailform')) {
            equalsfield = '[data-fieldname="' + equalsfield + '"]';
          } else {
            equalsfield = '[name="' + equalsfield + '"]';
          }
          // Überprüfen, ob das Feld existiert
          const equalsfieldElement = document.querySelector(equalsfield);
          if (equalsfieldElement) {
            if (value != equalsfieldElement.value) {
              status = false;
            }
          } else {
            status = false;
          }
        }
        if (rules.includes('float')) {
          regex = new RegExp('^[-]?[0-9]+([.,]{1}[0-9]+)?$');

          if (!value.match(regex)) {
            status = false;
          }
        }
        if (rules.includes('greaterthan')) {
          // TODO
        }
        if (rules.includes('inarray')) {
          // TODO
        }
        if (rules.includes('integer')) {
          regex = new RegExp('^[-]?[0-9]+$');

          if (!value.match(regex)) {
            status = false;
          }
        }
        if (rules.includes('ip')) {
          regex = new RegExp('^\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}$');

          if (!value.match(regex)) {
            status = false;
          }
        }
        if (rules.includes('length')) {
          // TODO
        }
        if (rules.includes('lessthan')) {
          // TODO
        }
        if (rules.includes('regexp')) {
          if (input.dataset.regexp) {
            regex = new RegExp(input.dataset.regexp);

            if (!value.match(regex)) {
              status = false;
            }
          }
        }
        if (rules.includes('uri')) {
          // TODO
        }
      }

      if (status === false) {
        // Wenn Regex NICHT zutrifft
        input.parentElement.classList.remove('good');
        input.parentElement.classList.add('bad');
      } else {
        // Falls kein Regex durchgeführt wird es Valide
        if (!input.parentElement.classList.contains('err')) {
          input.parentElement.classList.add('good');
          input.parentElement.classList.remove('bad');
        }
      }
    } else {
      // Leere Felder haben keine Validierung
      input.parentElement.classList.remove('bad');
      input.parentElement.classList.remove('good');
    }

    // Gibt es ein anderes Feld, welches auf dieses equals hat?
    var fieldname = '';
    // Bei Mailforms aus dem Typo3 wird ein data-attr verwendet, um ein Feld zu identifizieren. Bei anderen name
    const form = input.closest('form'); // Das nächstgelegene Formular
    if (form && form.parentElement.classList.contains('csc-mailform')) {
      fieldname = input.dataset.fieldname;
    } else {
      fieldname = input.name;
    }

    if (input.closest('form').querySelector('[data-rules*=equals]')) {
      if (input.closest('form').querySelector('[data-equalsfield=' + fieldname + ']')) {
        validateInput(input.closest('form').querySelector('[data-equalsfield=' + fieldname + ']'));
      }
    }
  }
};
// Global
window.validateInput = (input) => {
  validateInput(input);
};

// Funktion, um zu überprüfen, ob ein Element horizontal scrollbar ist
function hasHorizontalScrollBar(element) {
  return element.clientWidth < element.scrollWidth;
}

function initTabContent(from) {
  // Tab Content
  $(from).find('.tab-header > *').on('click', function() {
    const ele = $(this);
    const eleindex = ele.index();
    ele.addClass('active').siblings().removeClass('active');
    ele.closest('.tab-wrap').find('.tab-content').children().hide();
    ele.closest('.tab-wrap').find('.tab-content').children().eq(eleindex).show();
  });
}

// Global
window.initTabContent = (from) => {
  initTabContent(from);
};

function initFakeRadioCheckbox(from) {
  // Fake Checkbox und Radio klick
  const inputs = $(from).find('.csc-form-element-radio > .csc-field > i,.csc-form-element-checkbox > .csc-field > i, .input-radio > i, .input-checkbox > i');

  inputs.each(function() {
    if (!$(this).hasClass('js--fakeradiocheckbox-initialized')) {
      $(this).addClass('js--fakeradiocheckbox-initialized');
      $(this).on('click', function() {
        $(this).prev('input').trigger('click');
      });
    }
  });
}

// Global
window.initFakeRadioCheckbox = (from) => {
  initFakeRadioCheckbox(from);
};

$(window).on('load', function() {
  if (location.hash != '' && $(location.hash).length > 0) {
    var header = $('#header-inner');
    if ($(window).width() >= 1024 && $('html').hasClass('no-touchevents')) {
      header = $('#menu');
    }
    setTimeout(function() {
      $('html,body').animate({scrollTop: $(location.hash).offset().top - header.outerHeight()}, 0);
    }, 10);
  }

  $('a[href*="#"]').each(function() {
    var ele = $(this),
        href = ele.attr('href'),
        linkhash = href.split('#')[1];

    if (linkhash.length > 0) {
      // Nur wenn Element auf eigener Seite existiert
      if ($('#' + linkhash).length === 1) {
        ele.on('click', function(e) {
          e.preventDefault();
          var header = $('#header-inner');
          if ($(window).width() >= 1024 && $('html').hasClass('no-touchevents')) {
            header = $('#menu');
          }
          $('html,body').stop().animate({scrollTop: $('#' + linkhash).offset().top - header.outerHeight()}, 350);
        });
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // CSS-Klasse wechseln, wenn JS aktiviert ist (für Fallbacks)
  document.querySelector('html').classList.replace('no-js', 'js');

  // Photoswipe config
  const lightbox = new PhotoSwipeLightbox({
    gallery: '.pswp-gallery',
    children: '.pswp-gallery__item',
    showHideAnimationType: 'fade',
    pswpModule: () => import('photoswipe'),
  });
  // Photoswipe caption
  // eslint-disable-next-line
  new PhotoSwipeDynamicCaption(lightbox, {
    // Plugins options, for example:
    type: 'below',
    captionContent: (slide) => {
      // Caption aus figcaption ziehen
      return (slide.data.element.nextElementSibling ? slide.data.element.nextElementSibling.textContent : '');
    },
  });
  // YouTube Videos in Photoswipe
  // parse data-google-map-url attribute
  lightbox.addFilter('itemData', (itemData) => {
    const embedVideoUrl = itemData.element.dataset.embedVideoUrl;
    if (embedVideoUrl) {
      itemData.embedVideoUrl = embedVideoUrl;
    }
    return itemData;
  });
  // overwrite slide content
  lightbox.on('contentLoad', (e) => {
    const {content} = e;
    if (content.type === 'embed-video') {
      // prevent the deafult behavior
      e.preventDefault();

      // Create a container for iframe
      // and assign it to the `content.element` property
      content.element = document.createElement('div');
      content.element.className = 'pswp__embed-video-container';

      const iframe = document.createElement('iframe');
      iframe.setAttribute('allowfullscreen', 'allowfullscreen');
      iframe.setAttribute('frameborder', '0');
      iframe.src = content.data.embedVideoUrl;
      content.element.appendChild(iframe);
    }
  });

  lightbox.init();

  // Bypass-Menu Button
  document.querySelectorAll('.csc-menu-bypass').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const wrap = this.closest('.csc-frame');
      const scrollheight = wrap.offsetTop + wrap.offsetHeight;
      window.scrollTo({top: scrollheight, behavior: 'smooth'});
    });
  });

  // Ajax-Formulare
  document.querySelectorAll('.csc-mailform').forEach(function(form) {
    mpAjaxForm(form);
  });

  $('#main-menu > li.big:last > ul').addClass('rightul');

  // Responsive Menu
  // Menu-Button resettet die Classes vom Menü und lässt das Menü öffnen und schließen
  $('#menu-button').on('click', function() {
    var body = $('html');
    if (body.hasClass('menu-open')) {
      body.removeClass('menu-open');
      if ($('#menu-overlay').length) {
        $('#menu-overlay').stop().fadeOut(250, function() {
          $(this).remove();
        });
      }
    } else {
      body.addClass('menu-open');
      if (!$('#menu-overlay').length) {
        $('body').append('<div id="menu-overlay"></div>');
        $('#menu-overlay').hide().stop().fadeIn(250).on('click', function() {
          $('#menu-button').trigger('click');
        });
      }
      mobileMenuTopDistance();
    }
  });
  $('.submenu-open').on('click', function() {
    var ele = $(this);
    if (ele.parent('li').hasClass('open')) {
      ele.find('.fa-minus-circle').addClass('fa-plus-circle').removeClass('fa-minus-circle');
      ele.parent('li').removeClass('open');
      ele.siblings('ul').slideUp(250);
    } else {
      ele.find('.fa-plus-circle').addClass('fa-minus-circle').removeClass('fa-plus-circle');
      ele.parent('li').addClass('open');
      ele.siblings('ul').slideDown(250);
    }
  });

  /* Filter Trainingsübersicht */
  $('#tr-filter-toggle').on('click', function() {
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $('#tr-filter-wrap').stop().slideUp('250', function() {
        $(this).css('height', 'auto');
      });
    } else {
      $(this).addClass('open');
      $('#tr-filter-wrap').stop().slideDown('250', function() {
        $(this).css('height', 'auto');
      });
    }
  });
  $('.fake-select-label').on('click', function() {
    var ele = $(this);
    if (ele.closest('.fake-select').hasClass('open')) {
      ele.find('.fa-minus-circle').addClass('fa-plus-circle').removeClass('fa-minus-circle');
      ele.closest('.fake-select').removeClass('open').find('.fake-select-options').stop().slideUp(250);
    } else {
      ele.find('.fa-plus-circle').addClass('fa-minus-circle').removeClass('fa-plus-circle');
      ele.closest('.fake-select').addClass('open').find('.fake-select-options').stop().slideDown(250);

      // Alle anderen Filter-Elemente zuklappen! - nur für Desktop
      if ($('html').hasClass('no-touchevents') && $(window).width() >= 1024) {
        $(ele).closest('.fake-select').siblings('.fake-select').each(function() {
          if ($(this).hasClass('open')) {
            $(this).find('.fake-select-label').trigger('click');
          }
        });
      }
    }
  });

  // Trainingsfinder Checkboxen
  $('.fake-select-options input[type=checkbox]').on('click', function() {
    if ($(this).is(':checked') === true) {
      // Alle anderen Checkboxen deaktivieren
      $(this).closest('.input-checkbox').siblings('.input-checkbox').find('input[type=checkbox]').prop('checked', false);
      $(this).closest('form').submit(); // direkt absenden
    }
  });

  // Klappbox
  // Grid-Element
  $('.grid-foldbox > header').on('click', function() {
    var ele = $(this);
    ele.parent().toggleClass('open').children('.csc-grid-row:last-child').stop().slideToggle(200);
  });
  // Template (Buchungsschritt)
  $('.foldbox').each(function() {
    if (!$(this).hasClass('open')) {
      $(this).children('.foldbox-content').hide();
    }
  });
  $('.foldbox > .foldbox-header').on('click', function() {
    var ele = $(this);
    if (ele.parent('.foldbox').hasClass('open')) {
      ele.parent('.foldbox').removeClass('open').children('.foldbox-content').stop().slideUp(200);
    } else {
      ele.parent('.foldbox').addClass('open').children('.foldbox-content').stop().slideDown(200);
    }
  });
  $('.foldbox > .foldbox-content').find('.foldbox-close').on('click', function() {
    $(this).closest('.foldbox').children('.foldbox-header').trigger('click');
  });

  // Aktionshinweis
  if ($('.header-action-item').length) {
    $('.header-action-item').each(function() {
      var ele = $(this);

      // Schließen hinzufügen
      ele.find('.csc-frame').append(' <div class="header-action-button-wrap"><a href="#" class="header-action-button"><i class="far fa-times-circle"></i></a></div>');
      // Schließen Funktion
      ele.find('.header-action-button').on('click', function() {
        document.cookie = 'actionHint' + ele.data('uid') + '=1; path=/';
        ele.hide();
        return false;
      });

      // Hinweis anzeigen, wenn Cookie nicht gesetzt
      if (document.cookie.indexOf('actionHint' + ele.data('uid') + '=1') === -1) {
        ele.show();
      }
    });
  }

  // Beim Breacrumb ausblenden auch die grid-col ausblenden, wenn sie nur breadcrumb enthält, da sonst ein margin übrig bleibt
  $('.csc-breadcrumb').each(function() {
    var ele = $(this);
    if (ele.closest('.csc-grid-col').length) {
      var gridcol = ele.closest('.csc-grid-col');
      if (!gridcol.children().not('.csc-breadcrumb').length) {
        gridcol.addClass('csc-breadcrumb');
      }
    }
  });

  // Tooltips
  delegate('body', {
    target: '[data-tippy-content]',
    allowHTML: true,
    theme: 'light-border',
  });

  /* Bildausrichtung Polaroid - Link auf gesamtes Element */
  var panolinks = $('.csc-textmedia-polaroidgrid').find('a');
  if (panolinks.length) {
    panolinks.each(function() {
      var piclink = $(this).attr('href');
      $(this).parent('figure').addClass('hand').attr('data-link', piclink);
    });
    panolinks.parent('figure').on('click', function() {
      window.location.href = $(this).data('link');
    });
  }

  // Kopieren
  /*function copyToClipboard(element) {
   var $temp = $('<input>');
   $(element).prepend($temp);
   $temp.val($(element).text()).select();
   document.execCommand('copy');
   $temp.remove();
   }*/

  if (!$('body').hasClass('order')) {
    stickyHeaderControl();
    stickySectionmenuInit();

    footerMenuHeightDesktop();
  }

  initTabContent('body');

  handleRtePlugins();

  ajaxAdacForm();

  const inputsToValidate = document.querySelectorAll('#content input,#content textarea, #header input, #footer-info-newsletter input, #content select');
  inputsToValidate.forEach((input) => {
    // init
    validateInput(input);
    firstvalidate = false;
    // input evenut
    bubbleEvent(input, 'input', (e) => {
      const inputTarget = e.target;
      validateInput(inputTarget);
    });
    // change event
    bubbleEvent(input, 'change', (e) => {
      const inputTarget = e.target;
      validateInput(inputTarget);
    });
  });

  initFakeRadioCheckbox('body');

  // Google Maps Text innen
  var gmContainer = $('#gm-map-container');
  if (gmContainer.length > 0) {
    // Texte sammeln
    var args = {
      title: gmContainer.attr('data-title'),
      text: gmContainer.attr('data-subtitle'),
    };

    // Text hinzufügen wenn vorhanden
    if (typeof args.title !== 'undefined') {
      gmContainer.prepend('<div class="mood-txt-wrap"><div class="mood-txt"><div>' + args.title + '</div>' + (typeof args.text !== 'undefined' ? '<div>' + args.text + '</div>' : '') + '</div></div>');
    }
  }

  // Texte der Bildausrichtungen wrappen
  $('.csc-textmedia-teaser-content-left .csc-textmedia-text, .csc-textmedia-teaser-content-right .csc-textmedia-text').each(function() {
    $(this).wrapInner('<div class="csc-textmedia-text-inner"></div>');
  });

  var body = $('body');
  $('#search-desktop').toggle('slide', {direction: 'left'}, 1);
  // Mobile Suche öffnen
  $('#search-mobile-trigger').on('click', function() {
    body.toggleClass('search-open');
    if (body.hasClass('search-open')) {
      setTimeout(function() {
        $('#mobile-search-input').focus();
      }, 250);
    } else {
      $('#mobile-search-input').blur();
    }
  });
  // Desktop Suche öffnen
  $('#search-desktop-trigger').on('click', function() {
    var ele = $(this);
    // Seperator
    var sep = ele.prevAll('.sep');
    //var sepwidth = sep.outerWidth();
    // Custom Topmenu
    var topmenucustom = '';
    if ($(this).prevAll('.csc-frame-wrap').length) {
      topmenucustom = ele.prevAll('.csc-frame-wrap');
      //var topmenucustomwidth = topmenucustom.outerWidth();
    }
    // Suchfeld
    var searchfield = $('#search-desktop');

    // Handling
    body.toggleClass('search-open');
    if (body.hasClass('search-open')) {
      // Lupe zu Kreuz
      ele.removeClass('fa-search').removeClass('fas').addClass('fa-times').addClass('far');
      // Custom Topmenu ausblenden
      if (topmenucustom !== '') {
        topmenucustom.toggle('slide');
      }
      // Sep ausblenden
      sep.toggle('slide', function() {
        // Custom Topmenu ausblenden
        searchfield.toggle('slide');
      });
    } else {
      // Kreuz zu Lupe
      ele.addClass('fa-search').addClass('fas').removeClass('fa-times').removeClass('far');
      // Custom Topmenu ausblenden
      searchfield.toggle('slide', function() {
        // Sep ausblenden
        sep.toggle('slide');
        // Custom Topmenu ausblenden
        if (topmenucustom !== '') {
          topmenucustom.toggle('slide');
        }
      });
    }
  });

  // CopyToClipboard Buttons
  /*$('.copytoclipboard').each(function() {
   var ele = $(this);
   var copytxt = ele.text();
   ele.after('<span class="copytoclipboard-button" data-clipboard-text="' + copytxt + '"><i class="far fa-copy"></i>Kopieren</span>');
   });
   new ClipboardJS('.copytoclipboard-button');*/

  // Alle Elemente mit der Klasse "responsive-table" auswählen
  var tableElements = document.querySelectorAll('.responsive-table');

  // Iteriere durch die ausgewählten Elemente
  if (tableElements && tableElements.length > 0) {
    tableElements.forEach(function(element) {
      if (hasHorizontalScrollBar(element)) {
        element.classList.add('scrollable');
      } else {
        element.classList.remove('scrollable');
      }
    });
  }

  // Breadcrumb über Google Maps anzeigen
  if ($('#gm-map-container').length) {
    if ($('#content').children('.csc-frame-wrap:first').find('#gm-map-container').length && $('#breadcrumb-wrap').length) {
      $('#breadcrumb-wrap').addClass('overlay-breadcrumb');
    }
  }

  // Gesammelte Funktionen ausführen, weil jQuery erst im Footer geladen wird
  // eslint-disable-next-line no-undef
  $(functionsAfterLoad).each(function(k, v) {
    v();
  });

  // Menu-Buttons und Hero-Slider wrapen
  var heroSliderSelector = $('.csc-textmedia-moodimg');
  if (heroSliderSelector.length) {
    heroSliderSelector.closest('.csc-frame-wrap').addClass('csc-textmedia-moodimg-wrap');
  }
  var menuButtonSelector = $('.csc-menu-buttons');
  if (menuButtonSelector.length) {
    menuButtonSelector.closest('.csc-frame-wrap').addClass('csc-menu-buttons-wrap');
  }

  $('.csc-textmedia-moodimg-wrap').each(function() {
    var moodEle = $(this);
    moodEle.next('.csc-menu-buttons-wrap').add(moodEle).wrapAll('<div class=\'herowrap\' />');
  });

  // Slider-Bilder müssen vom LazyLoad ausgeschlossen und vorher geladen werden,
  // da sonst die Höhe der Bilder falsch bereitgehalten wird anhand der t3_blank.gif
  $('.grid-sliderbox img').each(function() {
    let src = $(this).attr('data-src');
    let srcset = $(this).attr('data-srcset');
    if ('img' === $(this).prop('tagName').toLowerCase()) {
      if (src) {
        $(this).attr('src', src);
      }
      if (srcset) {
        $(this).attr('srcset', srcset);
      }
    } else {
      $(this).css('background-image', 'url(\'' + src + '\')');
    }
    $(this).removeClass('lazyload');
  });
});

function updateOnTouchmoveAndScroll() {
  if (!document.body.classList.contains('order')) {
    stickyHeaderControl();
    mobileMenuTopDistance();
    stickySectionmenuControl();
  }
}

document.addEventListener('touchmove', updateOnTouchmoveAndScroll);
document.addEventListener('scroll', updateOnTouchmoveAndScroll);

function updateScrolltopButton() {
  // Scrolltop-Button
  const scrolltopButton = document.getElementById('scrolltop');
  if (scrolltopButton) {
    if (window.scrollY > 100) {
      scrolltopButton.classList.add('showit');
    } else {
      scrolltopButton.classList.remove('showit');
    }
  }
}

// Fügen Sie denselben Event-Handler für resize, touchmove und scroll hinzu
window.addEventListener('resize', updateScrolltopButton);
window.addEventListener('touchmove', updateScrolltopButton);
window.addEventListener('scroll', updateScrolltopButton);
window.addEventListener('resize', function() {
  if (!document.body.classList.contains('order')) {
    mobileMenuTopDistance();
    footerMenuHeightDesktop();
  }

  // Alle Elemente mit der Klasse "responsive-table" auswählen
  var tableElements = document.querySelectorAll('.responsive-table');

  // Iteriere durch die ausgewählten Elemente
  if (tableElements && tableElements.length > 0) {
    tableElements.forEach(function(element) {
      if (hasHorizontalScrollBar(element)) {
        element.classList.add('scrollable');
      } else {
        element.classList.remove('scrollable');
      }
    });
  }
});

window.addEventListener('load', function() {
  // Fügt der HTML-Elementklasse "winload" hinzu
  document.documentElement.classList.add('winload');

  if (!document.body.classList.contains('order')) {
    // Wenn der body keine Klasse "order" hat, rufen Sie die Funktion stickySectionmenuControl auf
    stickySectionmenuControl();
  }

  // Scrolltop-Button
  const scrolltopButton = document.getElementById('scrolltop');
  scrolltopButton.addEventListener('click', function() {
    // Beim Klicken auf den Button wird zur Spitze der Seite animiert
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });

  // Überwacht das Scrollen des Dokuments und zeigt/versteckt den Scrolltop-Button basierend auf dem Scrollwert
  const scrolltopWrap = document.getElementById('scrolltop-wrap');
  if (window.scrollY > 100) {
    scrolltopWrap.classList.add('showit');
  } else {
    scrolltopWrap.classList.remove('showit');
  }
});

/**
 * refreshAdacParams
 * @param params
 */
function refreshAdacParams(params) {
  // Eine zufällige Zahl generieren, um sicherzustellen, dass der Cache umgangen wird
  const randomValue = Math.random();

  // Die URL für die Anforderung erstellen
  const url = `ajax/ajax.adac_params.php?${params}&_r=${randomValue}`;

  // Die Daten über die Fetch-API laden
  fetch(url).then(response => response.text()).then(data => {
    // Den geladenen Inhalt in das Element mit der ID "clndr" einfügen
    const clndrElement = document.getElementById('clndr');
    clndrElement.innerHTML = data;

    // Führe alle <script> Tags im eingefügten HTML mit data-guid aus
    const scriptTags = clndrElement.querySelectorAll('script');
    for (let i = 0; i < scriptTags.length; i++) {
      const scriptCode = scriptTags[i].textContent || scriptTags[i].innerText;

      const executeScript = new Function(scriptCode);
      executeScript();
    }
  }).catch(error => {
    console.error('Fehler beim Laden der Daten:', error);
  });
}

// Global
window.refreshAdacParams = (params) => {
  refreshAdacParams(params);
};

// eslint-disable-next-line no-unused-vars
function showAjaxLoader() {
  if (!document.querySelector('#ajaxloader')) {
    const ajaxLoader = document.createElement('div');
    ajaxLoader.id = 'ajaxloader';
    ajaxLoader.innerHTML = '<div class="loader"><div></div><div></div><div></div><div></div></div>';
    document.body.appendChild(ajaxLoader);
  }
}

// Global
window.showAjaxLoader = () => {
  showAjaxLoader();
};

// eslint-disable-next-line no-unused-vars
function hideAjaxLoader() {
  const ajaxLoader = document.querySelector('#ajaxloader');
  if (ajaxLoader) {
    ajaxLoader.parentNode.removeChild(ajaxLoader);
  }
}

// Global
window.hideAjaxLoader = () => {
  hideAjaxLoader();
};